<template>
  <!-- <div> -->
  <div id="searchBar" class="rightSearch">
    <el-form :inline="true" label-position="right" label-width="140px">
      <el-row :gutter="24">
        <!--    -->
        <el-col :span="8">
          <el-form-item label="文章ID检索">
            <el-input
              v-model.number="form.articleId"
              placeholder="请输入文章ID进行检索"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="请输入文章关键词">
            <el-input
              v-model="form.articleKeyWord"
              placeholder="请输入文章ID进行检索"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="疾病检索">
            <el-select
              v-model="form.diseaseLabel"
              multiple
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
              class="text"
              @change="changeValue()"
            >
              <el-option
                v-for="item in diseaseList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="写手昵称检索">
            <el-input
              v-model="form.nickname"
              placeholder="请输入写手昵称"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="写手pin检索">
            <el-input
              v-model="form.writerPin"
              placeholder="请输入写手pin"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="医生姓名检索">
            <el-input
              v-model="form.doctorName"
              placeholder="请输入医生姓名"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="科室检索">
            <el-input
              v-model="form.department"
              placeholder="请输入科室名称"
              class="text"
              @change="changeValue()"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="投稿时间">
            <el-date-picker
              v-model="form.submissionTime"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
              @change="changeValue()"
              value-format=" yyyy-MM-dd"
              format="yyyy-MM-dd"
              class="text"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="精选文章">
            <el-select
              v-model="form.featuredArticle"
              placeholder="请选择"
              class="text"
              @change="changeValue()"
            >
              <el-option
                v-for="item in featuredList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="文章标签">
            <el-select
              v-model="form.articleLable"
              placeholder="请选择"
              class="text"
              @change="changeValue()"
            >
              <el-option
                v-for="item in articleLableList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="是否原创">
            <el-select
              v-model="form.isOriginal"
              placeholder="请选择"
              class="text"
              @change="changeValue()"
            >
              <el-option
                v-for="item in originalList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="是否置顶">
            <el-select
              v-model="form.isTop"
              placeholder="请选择"
              class="text"
              @change="changeValue()"
            >
              <el-option
                v-for="item in topList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <span class="btn-search" @click="searchInfos">查询</span>
        <span class="btn-clear" @click="clearInfos">清除</span>
      </el-form-item>
    </el-form>

    <!-- <ul class="clear"> -->
    <!-- <li class="group">
          <span class="title">文章ID检索</span>
          <el-input
            v-model="form.articleId"
            placeholder="请输入文章ID进行检索"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">请输入文章关键词</span>
          <el-input
            v-model="form.articleKeyWord"
            placeholder="请输入文章ID进行检索"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">疾病检索</span>
          <el-select
            v-model="form.diseaseLabel"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in diseaseList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- <li class="group">
          <span class="title">写手昵称检索</span>
          <el-input
            v-model="form.nickname"
            placeholder="请输入写手昵称"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">写手pin检索</span>
          <el-input
            v-model="form.writerPin"
            placeholder="请输入写手pin"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">医生姓名检索</span>
          <el-input
            v-model="form.doctorName"
            placeholder="请输入医生姓名"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">医院名称检索</span>
          <el-input
            v-model="form.hospital"
            placeholder="请输入医院名称"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">科室检索</span>
          <el-input
            v-model="form.department"
            placeholder="请输入科室名称"
            class="text"
            @change="changeValue()"

          ></el-input>
        </li> -->
    <!-- <li class="group">
          <span class="title">文章类型</span>
          <el-select
            v-model="form.articleType"
            placeholder="请选择"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in articleTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- <li class="group">
          <span class="title">投稿时间</span>
          <el-date-picker
            v-model="form.submissionTime"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="changeValue()"
            value-format=" yyyy-MM-dd"
            format="yyyy-MM-dd"
            class="text"
          >
          </el-date-picker>
        </li> -->
    <!-- <li class="group">
          <span class="title">精选文章</span>
          <el-select
            v-model="form.featuredArticle"
            placeholder="请选择"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in featuredList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- <li class="group">
          <span class="title">文章标签</span>
          <el-select
            v-model="form.articleLable"
            placeholder="请选择"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in articleLableList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- <li class="group">
          <span class="title">是否原创</span>
          <el-select
            v-model="form.isOriginal"
            placeholder="请选择"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in originalList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- <li class="group">
          <span class="title">是否置顶</span>
          <el-select
            v-model="form.isTop"
            placeholder="请选择"
            class="text"
            @change="changeValue()"

          >
            <el-option
              v-for="item in topList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </li> -->
    <!-- </ul>
      <div class="right-search-btns">
        <span class="btn-search" @click="searchInfos">查询</span>
        <span class="btn-clear" @click="clearInfos">清除</span>
      </div>
    </div> -->
    <!-- <div class="to-search">

      <el-input
        v-model="search_val"
        placeholder="输入文章ID/关键词/疾病/手写昵称/手写PIN/医生姓名/医院名称进行搜索"
      ></el-input
      ><el-button type="primary" icon="el-icon-search">搜索</el-button>
    </div> -->
    <!-- <el-select class="select l" v-model="articleVal" placeholder="全部文章">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select class="select l" v-model="talentName" placeholder="全部达人昵称">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      class="select l"
      v-model="articletypes"
      placeholder="全部文章类型"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div class="selectDate">
      <el-date-picker
        class="date-picker"
        v-model="dateValue"
        type="date"
        placeholder="选择投稿时间"
      >
      </el-date-picker>
    </div>

    <el-select
      class="select l"
      v-model="allBusiness"
      placeholder="全部所属业务"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select class="select l" v-model="allTypes" placeholder="全部类型">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <span class="btn-reset r">重置</span> -->
  </div>
</template>

<script>
// import myInput from '../components/myInput.vue'
import { listContentUserLabels } from "@/api/user";
export default {
  components: {
    // myInput
  },
  created() {
    this.getContentLabels();
  },
  name: "search",
  data() {
    return {
      form: {
        articleId: "", //文章ID
        articleKeyWord: "", // 文章关键字
        diseaseLabel: [], // 疾病标签
        nickname: "", // 写手昵称
        writerPin: "", // 写手Pin
        doctorName: "", // 医生名字
        hospital: "", // 医院名称
        department: "", // 科室名称
        articleType: "", // 文章类型
        submissionTime: "", // 投稿时间
        featuredArticle: "", // 精选文章
        // articleLable: '', // 文章标签
        isOriginal: "", // 是否原创
        isTop: "", // 是否置顶
      },
      originalList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      articleTypeList: [
        {
          value: 1,
          label: "图文",
        },
        {
          value: 2,
          label: "搭配",
        },
        {
          value: 3,
          label: "京装",
        },
        {
          value: 4,
          label: "帮助",
        },
        {
          value: 5,
          label: "单空间",
        },
        {
          value: 6,
          label: "整层",
        },
        {
          value: 7,
          label: "视频",
        },
        {
          value: 10,
          label: "文章子文章",
        },
      ],
      articleLableList: [],
      topList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      featuredList: [
        {
          value: 2,
          label: "是",
        },
        {
          value: 1,
          label: "否",
        },
      ],
      diseaseList: [],
      loading: false,
    };
  },
  methods: {
    changeValue() {
      this.$emit("getChangeValue", this.form);
    },
    // 筛选条件
    searchInfos() {
      this.changeValue();
    },
    clearInfos() {
      this.form = {
        articleId: null, //文章ID
        articleKeyWord: null, // 文章关键字
        diseaseLabel: null, // 疾病标签
        nickname: null, // 写手昵称
        writerPin: null, // 写手Pin
        doctorName: null, // 医生名字
        hospital: null, // 医院名称
        department: null, // 科室名称
        articleType: null, // 文章类型
        submissionTime: null, // 投稿时间
        featuredArticle: null, // 精选文章
        articleLable: null, // 文章标签
        isOriginal: null, // 是否原创
        isTop: null, // 是否置顶
      };
      this.$emit("clearInfos");
    },
    remoteMethod() {},
    getContentLabels() {
      listContentUserLabels({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        res.forEach((item) => {
          this.articleLableList.push({
            value: item.id,
            label: item.name,
          });
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rightSearch {
  padding: 20px 0px 40px 33px;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 15px;
  width: 100%;
  height: 100%;
  min-width: 1800px;
  .clear {
    margin-left: -23px;
  }
  .group {
    width: 33.3%;
    height: 50px;
    float: left;
  }
  .title {
    font-size: 15px;
    margin-right: 20px;
    color: #95a0a7;
  }
  .text {
    width: 100%;
    // height: 28px;
    font-size: 15px;
    // border: solid 1px #e4e9ec;
    background: #fafbfb;
    // margin-right: 40px;
  }
  .select .el-input__inner {
    width: 100%;
    height: 30px;
    font-size: 15px !important;
    padding-left: 8px;
    border: none;
    background: #fafbfb;
    margin-right: 40px;
  }
  .el-select__input {
    font-size: 15px !important;
    margin-top: 12px !important;
  }
}
.right-search-btns {
  float: right;
  margin-right: 79px;
  margin-top: 41px;
}
.btn-search {
  display: inline-block;
  width: 108px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: white;
  text-align: center;
  background-color: #ff6e00;
  margin-right: 20px;
  cursor: pointer;
}
.btn-clear {
  display: inline-block;
  width: 106px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #ff6e00;
  font-size: 14px;
  color: #ff6e00;
  text-align: center;
  background-color: #ffffff;
  cursor: pointer;
}
:deep(.el-form-item__content) {
  width: 100%;
}
</style>
